export default __webpack_public_path__ + "static/media/10-SalesForce-Logo3.de42d097.png";